import moment from "moment";
import { isFunction } from "./index";
import I18n from "../i18n/index";
const toStartEndOfDate = (start,end)=>{
	start.set({hour:0,minute:0,second:0,millisecond:0});
	end.set({hour:23,minute:59,second:59,millisecond:0});
};
/**
 * Get today date range as array of moment object
 * [start_of_day, end_of_day]
 * @param {function} converter
 */
const getTodayDateRange = (converter = undefined)=>{
	const start = moment(moment.now(),"x");
	const end = moment(moment.now(),"x");
	start.set({hour:0,minute:0,second:0,millisecond:0});
	end.set({hour:23,minute:59,second:59,millisecond:0});
	if(isFunction(converter)){
		return [converter(start), converter(end)];
	}
	return [start,end];
};
/**
 * Get current month date range.
 * @param {function} converter
 */
const getCurrentMonthDateRange = (converter = undefined)=>{
	const start = moment(moment.now(),"x").startOf("month");
	const end = moment(moment.now(),"x").endOf("month");
	if(isFunction(converter)){
		return [converter(start), converter(end)];
	}
	return [start,end];
};
const getAllTimeDateRange = (converter = undefined)=>{

	// const start = moment(moment.now(),"x").subtract(3, 'year').startOf("month");
	const start = moment("2015-01-01 00:00 +0000", "YYYY-MM-DD HH:mm Z");
	const end = moment(moment.now(),"x").endOf("month");
	if(isFunction(converter)){
		return [converter(start), converter(end)];
	}
	return [start,end];
};
const toRangeString = (startMoment, endMoment, format = "DD MMM YYYY")=>{
	if(startMoment===undefined || endMoment === undefined){
		return I18n.t("all_time");
	}
	return `${startMoment.format(format)} - ${endMoment.format(format)}`;
};
export default {
	toStartEndOfDate,
	getTodayDateRange,
	getAllTimeDateRange,
	getCurrentMonthDateRange,
	toRangeString
};



// WEBPACK FOOTER //
// ./src/util/aDate.js